import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { Tag } from '@delmonicos/shared-design-system-react/src/components/tag/tag';
import {
  Text,
  TextColor,
  TextFontSize,
} from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { AccentTitle } from '@delmonicos/shared-design-system-react/src/components/typography/title/accent-title/accent-title';
import { HeadingEnum } from '@delmonicos/shared-design-system-react/src/models/enums/heading.enum';
import { useTranslation } from 'react-i18next';

import { useCpmsBoGetChannelStatusesStatisticsQuery } from '@service/cpms-bo-channels-statistics.service';

export const NetworkHeadlineComponent = (): React.JSX.Element => {
  const { isSuccess, isLoading, data } =
    useCpmsBoGetChannelStatusesStatisticsQuery({});
  const { t } = useTranslation();

  return (
    <Stack gap={GapEnum.XXL} justifyContent="space-between">
      <Stack flex={1}>
        <AccentTitle
          as={HeadingEnum.H2}
          icon="server-06"
          text={t('$.dashboard.network.title')}
        />
      </Stack>
      <Tag className="bg-surface-brand" flex={1}>
        <Stack gap={GapEnum.S} alignItems="center">
          <Text bold color={TextColor.Primary} fontSize={TextFontSize.Large}>
            {isSuccess &&
              data?.value.reduce((carry, { total }) => carry + total, 0)}
            {isLoading && '-'}
          </Text>
          <Text color={TextColor.Primary}>
            {t('$.dashboard.network.connectors.total')}
          </Text>
        </Stack>
      </Tag>
    </Stack>
  );
};
